// extracted by mini-css-extract-plugin
module.exports = {"heading":"_question_slug__heading__dh2qO","questionBox":"_question_slug__questionBox__VlIS8","button":"_question_slug__button__1cGDo","sending":"_question_slug__sending__1m4ym"};